export const NOTAS_EXPLICATIVA = 'NOTAS_EXPLICATIVA';
export const NOTAS_EXPLICATIVA_START = 'NOTAS_EXPLICATIVA_START';
export const NOTAS_EXPLICATIVA_SUCCESS = 'NOTAS_EXPLICATIVA_SUCCESS';
export const NOTAS_EXPLICATIVA_ERROR = 'NOTAS_EXPLICATIVA_ERROR';

export const NOTAS_EXPLICATIVA_MENU = 'NOTAS_EXPLICATIVA_MENU';
